import { useDashboard } from '../context/DashboardContext';
import { t } from '../i18n';
import type { DataScope, Segment } from '../types/analytics';
import type { CompareMode } from '../utils/dateRange';

function Segmented<T extends string>({ label, value, options, onChange }: { label: string; value: T; options: Array<{ id: T; label: string; title?: string }>; onChange: (id: T) => void }) {
  return <div className="segmented" role="group" aria-label={label}>
    <span className="segmented-label">{label}</span>
    {options.map((option) => <button key={option.id} type="button" title={option.title} aria-pressed={option.id === value} className={option.id === value ? 'active' : ''} onClick={() => onChange(option.id)}>{option.label}</button>)}
  </div>;
}

/** Scope (internal devices in or out), account segment and comparison. Choices persist for the viewer. */
export function FilterBar() {
  const { filters, setFilters, compare, setCompare } = useDashboard();
  return <div className="filter-bar" aria-label={t('v1.filters.label')}>
    <Segmented<DataScope> label={t('v1.filters.devices')} value={filters.scope} onChange={(scope) => setFilters({ ...filters, scope })} options={[
      { id: 'filtered', label: t('v1.filters.exclInternal'), title: t('v1.filters.exclInternalTitle') },
      { id: 'raw', label: t('v1.filters.allDevices'), title: t('v1.filters.allDevicesTitle') },
    ]} />
    <Segmented<Segment> label={t('v1.filters.account')} value={filters.segment} onChange={(segment) => setFilters({ ...filters, segment })} options={[
      { id: 'all', label: t('v1.filters.all') }, { id: 'guest', label: t('v1.filters.guests') }, { id: 'registered', label: t('v1.filters.registered') },
    ]} />
    <Segmented<CompareMode> label={t('v1.filters.compare')} value={compare} onChange={setCompare} options={[
      { id: 'off', label: t('v1.filters.off') }, { id: 'previous', label: t('v1.filters.previous') }, { id: 'week', label: t('v1.filters.week') },
    ]} />
  </div>;
}
